type ChatProvider = 'sendbird' | 'matrix';

interface Config {
  API_HOST?: string;
  API_HOST_DEV?: string;
  FEHAP_API_HOST?: string;
  SENDBIRD_APP_ID?: string;
  PRO_SANTE_CONNECT_HOST?: string;
  PRO_SANTE_CONNECT_CLIENT_ID?: string;
  PRO_SANTE_CONNECT_AUTH_HOST?: string;
  CHAT_PROVIDER: ChatProvider;
  MATRIX_HS_URL: string;
  CARE_PROGRAMS_ENABLED: boolean;
  TERMS_OF_SERVICE_URL: string;
  PRIVACY_POLICY_URL: string;
  VERSION: string;
  RELEASE_DATE: string;
  JITSI_DOMAIN: string;
  AWS_REGION: string;
  JITSI_SCREEN_SHARING_ENABLED: boolean;
}

const config: Config = {
  API_HOST: process.env.REACT_APP_API_HOST,
  API_HOST_DEV: process.env.REACT_APP_API_HOST_DEV,
  FEHAP_API_HOST: process.env.REACT_APP_FEHAP_API_HOST,
  SENDBIRD_APP_ID: process.env.REACT_APP_SENDBIRD_APP_ID,
  PRO_SANTE_CONNECT_HOST: process.env.REACT_APP_PRO_SANTE_CONNECT_HOST,
  PRO_SANTE_CONNECT_CLIENT_ID:
    process.env.REACT_APP_PRO_SANTE_CONNECT_CLIENT_ID,
  PRO_SANTE_CONNECT_AUTH_HOST:
    process.env.REACT_APP_PRO_SANTE_CONNECT_AUTH_HOST,
  CHAT_PROVIDER:
    (process.env.REACT_APP_CHAT_PROVIDER as ChatProvider) || 'sendbird',
  MATRIX_HS_URL: process.env.REACT_APP_MATRIX_HS_URL || 'http://synapse:8008',
  CARE_PROGRAMS_ENABLED:
    process.env.REACT_APP_CARE_PROGRAMS_FEATURE_FLAG === 'true',
  TERMS_OF_SERVICE_URL:
    process.env.REACT_APP_TERMS_OF_SERVICE_URL ||
    'https://alakinhealth.com/terms',
  PRIVACY_POLICY_URL:
    process.env.REACT_APP_PRIVACY_POLICY_URL ||
    'https://alakinhealth.com/privacy',
  VERSION: process.env.REACT_APP_VERSION || '1',
  RELEASE_DATE: process.env.REACT_APP_RELEASE_DATE || '161224',
  JITSI_DOMAIN: process.env.REACT_APP_JITSI_DOMAIN || '',
  AWS_REGION: process.env.REACT_APP_AWS_REGION || 'eu-west-3',
  JITSI_SCREEN_SHARING_ENABLED:
    process.env.REACT_APP_JITSI_SCREEN_SHARING_FEATURE_FLAG === 'true',
};

export default config;
